function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.264 16.285C10.523 16.709 10.965 17.002 11.5 17.002H12H12.596C13.372 17.002 14 16.373 14 15.598C14 14.954 13.561 14.393 12.937 14.235L11.062 13.764C10.439 13.608 10 13.047 10 12.403C10 11.627 10.629 10.999 11.404 10.999H12H12.5C13.033 10.999 13.475 11.291 13.733 11.714M12 11V10V11ZM12 17V18V17Z",
  stroke: "#3A3A3A",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.174 7.5V5.5C16.174 4.395 15.279 3.5 14.174 3.5H9.826C8.721 3.5 7.826 4.395 7.826 5.5V7.5M19 20.5H5C3.895 20.5 3 19.605 3 18.5V9.5C3 8.395 3.895 7.5 5 7.5H19C20.105 7.5 21 8.395 21 9.5V18.5C21 19.605 20.105 20.5 19 20.5Z",
  stroke: "#3A3A3A",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgFinancial = function SvgFinancial(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFinancial, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/financial.646c320e.svg";
export { ForwardRef as ReactComponent };